import React from 'react';
import { Card, Typography } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    root: {
        margin: '16px 0px',
        padding: 16
    },
    header: {
        fontSize: 24,
        marginTop: 16,
        lineHeight: '28px'
    }
}));

const ContentDescription = () => {
    const classes = useStyles();
    return (
        <Card className={classes.root}>
            <Typography component="h1" className={classes.header}>
                ListenOnRepeat Podcasts
            </Typography>
            <Typography component="p">
                Your favourite ListenOnRepeat now comes with a new Podcasts feature where you can discover and listen to trending podcasts for free. Our ambition to present the world’s most listened podcasts and provide users with an ultimate podcasting experience is now at your fingertips.
            </Typography>
            <br />
            <Typography component="p">
                You can now browse and listen to podcasts from different genres including: Arts, History, TV, Movies, Crime, Health, Comedy and more with thousands of podcasts shuffled every day. Search and listen to podcasts from top podcasting channels like: This American Life, The Daily, TED Talks Daily, Serial, Crime Junkie and much more, all just a click away.
            </Typography>
            <Typography component="h2" className={classes.header}>
                Popular Free Podcasts {new Date().getFullYear()}
            </Typography>
            <Typography component="p">
                You can now listen to podcasts at all times while walking, cooking, working out or before going to bed. Listen to comedy podcasts if you need a laugh or a motivation podcast to motivate yourself. Listen to health podcasts if you need fitness advice. We work 24/7 to curate these top podcasts that you can listen to. Just click on the “Most Popular” button on the menu and the most recent podcasts are there for you to play. Discover trending podcasts, heart your favourites, and share it with the world. Below are few of the popular podcasts that will get you started in {new Date().getFullYear()}:
                <ol type="1">
                    <li>The Daily</li>
                    <li>This American Life</li>
                    <li>Crime Junkie</li>
                    <li>The Laverne Cox Show</li>
                    <li>Modern Love</li>
                    <li>Office Ladies</li>
                    <li>The Joe Rogan Experience</li>
                    <li>NPR News Now</li>
                    <li>The Ben Shapiro Show</li>
                    <li>Up First</li>
                </ol>
                What are you waiting for? Sign-up to ListenOnRepeat today and enjoy the unlimited access to thousands of Podcasts worldwide for free!
            </Typography>
        </Card>
    );
}

export default ContentDescription;
